import { VcfDomain } from 'pcs-domain';
import { IWldInputProductConfig } from "../wld-input-configuration-factory.service";

export class VCF_9_1_0_STANDARD_MANAGEMENT implements IWldInputProductConfig {
    configuration: VcfDomain.Group = {
        "groupId": "managementDomainComponents",
        "groupName": "Management Domain Components",
        "groupLabel": "Management Domain component sizes for VCF 9.1.0.",
        "subGroups": [
            {
                "id": 59,
                "subGroupId": "VMSP",
                "subGroupName": "VCF Management Services",
                "label": "Includes VCF Services Runtime + Fleet LCM + Fleet Depot + VIDB + Salt-RaaAS",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/design/vmware-cloud-foundation-concepts/vcf-management-services-models.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 3,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "availabilityType": "NON-HA", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 20,
                "subGroupId": "SDDC-MANAGER",
                "subGroupName": "Deploy SDDC Manager",
                "label": "SDDC Manager has only one-size and selected by default.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/fleet-management/vcf-shutdown-and-startup/sddc-startup/start-the-management-domain/start-the-sddc-manager-virtual-machine-in-the-management-domain.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "FIXED",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            {
                                "id": "FIXED",
                                "overheads": [{
                                    "id": "",
                                    "name": "",
                                    "resources": {}
                                }]
                            }
                        ]
                    }
                ]
            },
            {
                "id": 60,
                "subGroupId": "LICENSE_SERVER",
                "subGroupName": "Deploy License Server",
                "label": "License Server centralizes license management for VCF components.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/deployment/upgrading-cloud-foundation/deploy-vcf-management-services.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "STANDARD",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "STANDARD", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 35,
                "subGroupId": "VCENTER",
                "subGroupName": "Deploy VMware vCenter",
                "label": "You can choose the size of vCenter for the Management Domain. We will provide you with the sizing recommendation.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/infrastructure-operations/network-operationss/working-with-data-sources/adding-a-data-source-in-vrealize-network-insight/supported-vmware-managers/add-vcenter-server.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy vCenter *",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "SMALL",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "TINY", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 21,
                "subGroupId": "NSX-MANAGER",
                "subGroupName": "Deploy VMware NSX Manager",
                "label": "You can have a dedicated NSX manager for the Management domain.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/advanced-network-management/nsx-manager.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy NSX Manager *",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "availabilityType": "NON-HA", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 36,
                "subGroupId": "NSX-EDGE",
                "subGroupName": "Deploy VMware NSX Edge",
                "label": "You can choose NSX Edge for the Management Domain based on your throughput requirement.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/advanced-network-management/installing-nsx-edge.html",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy NSX Edge *",
                        "isRequired": false,
                        "isEnabled": false,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 0,
                "subGroupId": "VCF_OPERATIONS_COMPOSITE",
                "subGroupName": "Deploy VCF Operations",
                "label": "This includes VCF Operations and Cloud Proxy",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/overview-of-vmware-cloud-foundation-9/what-is-vmware-cloud-foundation-and-vmware-vsphere-foundation/vcf-operations-overview.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "vcfOperationsSizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy VCF Operations *",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms":0,
                        "predicate": {},
                        "options": [],
                        "componentId": "VCF_OPERATIONS",
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    },
                    {
                        "id": "vcfOperationsCollectorSizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy Cloud Proxy *",
                        "isRequired": true,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentId": "VCF_OPERATIONS_COLLECTOR",
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "STANDARD", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 22,
                "subGroupId": "VCF_OPERATIONS",
                "subGroupName": "VCF Operations",
                "label": "Management monitoring and operations.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/overview-of-vmware-cloud-foundation-9/what-is-vmware-cloud-foundation-and-vmware-vsphere-foundation/vcf-operations-overview.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy VCF Operations *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 23,
                "subGroupId": "FLEET_MANAGEMENT",
                "subGroupName": "Fleet Management",
                "label": "Fleet Management component.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/fleet-management.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy Fleet Management *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "FIXED",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            {
                                "id": "FIXED",
                                "overheads": [{
                                    "id": "",
                                    "name": "",
                                    "resources": {}
                                }]
                            }
                        ]
                    }
                ]
            },
            {
                "id": 24,
                "subGroupId": "VCF_OPERATIONS_COLLECTOR",
                "subGroupName": "Cloud Proxy",
                "label": "Cloud Proxy for management domain.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/deployment/upgrading-cloud-foundation/upgrade-backup-and-restore/configuring-cloud-proxies-in-vrealize-operations-cloud.html",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy Cloud Proxy *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "STANDARD", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 0,
                "subGroupId": "VRNI_COMPOSITE",
                "subGroupName": "Deploy VCF Operations for Networks",
                "label": "This includes VCF Operations for Network Platform and VCF Operations for Network Collector",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/deployment/deploying-a-new-vmware-cloud-foundation-or-vmware-vsphere-foundation-private-cloud-/manual-deployment-of-components-to-complete-your-vcf-platform/installing-vcf-networks.html",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "vrniSizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy VCF Operations for Network Platform *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 3,
                        "predicate": {},
                        "options": [],
                        "componentId": "VRNI",
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "2X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    },
                    {
                        "id": "vrniCollectorSizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy VCF Operations for Network Collector *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 3,
                        "predicate": {},
                        "options": [],
                        "componentId": "VRNI_COLLECTOR",
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "2X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 27,
                "subGroupId": "VRNI",
                "subGroupName": "VCF Operations for Network Platform",
                "label": "Network insights and analytics for VCF 9.1.0.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/deployment/deploying-a-new-vmware-cloud-foundation-or-vmware-vsphere-foundation-private-cloud-/manual-deployment-of-components-to-complete-your-vcf-platform/installing-vcf-networks.html",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy VCF Operations for Network Platform *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "2X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 28,
                "subGroupId": "VRNI_COLLECTOR",
                "subGroupName": "Deploy VCF Operations for Network Collector",
                "label": "Network collector for VCF Operations for Networks.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/deployment/deploying-a-new-vmware-cloud-foundation-or-vmware-vsphere-foundation-private-cloud-/manual-deployment-of-components-to-complete-your-vcf-platform/installing-vcf-networks.html",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy VCF Operations for Network Collector *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "2X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 26,
                "subGroupId": "VCF_AUTOMATION",
                "subGroupName": "Deploy VCF Automation",
                "label": "Delivers a unified, API-driven private cloud experience, integrating infrastructure-as-code (IaC), self-service provisioning, and governance.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/overview-of-vmware-cloud-foundation-9/what-is-vmware-cloud-foundation-and-vmware-vsphere-foundation/vcf-automation-overview.html",
                "documentLabel": "Learn More",
                "isEnabled": true,
                "isRequired": false,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy VCF Automation *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "MEDIUM",
                        "minNumberOfVms": 0,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "MEDIUM", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            },
            {
                "id": 29,
                "subGroupId": "AVI_CONTROLLER",
                "subGroupName": "Deploy AVI Controller",
                "label": "AVI Controller for load balancing and application delivery.",
                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-9-0-and-later/9-1/infrastructure-operations/network-operationss/support-for-load-balancers/nsx-advanced-load-balancer.html",
                "documentLabel": "Learn More",
                "isEnabled": false,
                "isRequired": true,
                "inputs": [
                    {
                        "id": "sizing",
                        "type": "COMPONENT_DROPDOWN",
                        "label": "Pick the appropriate size to deploy AVI Controller *",
                        "isRequired": false,
                        "isEnabled": true,
                        "default": "LARGE",
                        "minNumberOfVms": 3,
                        "predicate": {},
                        "options": [],
                        "componentSizing": [
                            { "id": "SMALL", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] },
                            { "id": "X-LARGE", "overheads": [{ "id": "", "name": "", "resources": {} }] }
                        ]
                    }
                ]
            }
        ]
    };

    getProductInfo(): string { throw new Error("Method not implemented."); }
    getDatabaseConnectionString(): string { throw new Error("Method not implemented."); }
    getApiEndpoint(): string { throw new Error("Method not implemented."); }
    getDeploymentStrategy(): string { throw new Error("Method not implemented."); }
}
